const { gamerskyAgentImage } = require("./valorantRecordDetails");

function normalizeDataSource(value) {
    return String(value || "TRACKER").toUpperCase() === "RIOT_PD" ? "RIOT_PD" : "TRACKER";
}

function splitAccountName(value) {
    const text = String(value || "");
    const separator = text.indexOf("#");
    return separator < 0
        ? { playerName: text, playerId: "" }
        : { playerName: text.slice(0, separator), playerId: text.slice(separator + 1) };
}

function displayValue(value, fallback) {
    return value !== null && value !== undefined && value !== "" ? value : fallback;
}

function formatMatchTime(match) {
    const millis = Number(match && match.playTimeMillis);
    if (!Number.isFinite(millis) || millis <= 0) return displayValue(match && match.playTime, "--");
    const date = new Date(millis);
    if (Number.isNaN(date.getTime())) return "--";
    const pad = value => String(value).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function formatDuration(seconds) {
    const value = Number(seconds);
    if (!Number.isFinite(value) || value <= 0) return "0s";
    const whole = Math.floor(value);
    const minutes = Math.floor(whole / 60);
    const remainder = whole % 60;
    return minutes ? `${minutes}m${remainder}s` : `${remainder}s`;
}

function normalizePlayer(item) {
    const account = splitAccountName(item && item.valorantUserName);
    return {
        ...(item || {}),
        playerName: displayValue(item && item.playerName, account.playerName || "--"),
        playerId: displayValue(item && item.playerId, account.playerId),
        heroImageUrl: gamerskyAgentImage(item && (item.heroName || item.heroId))
            || displayValue(item && item.heroImageUrl, ""),
        segmentImgUrl: displayValue(item && item.segmentImgUrl, ""),
        gameKda: displayValue(item && item.gameKda, "0/0/0"),
        gameKd: displayValue(item && item.gameKd, 0),
        avgCombatScore: displayValue(item && item.avgCombatScore, "--"),
        avgDamage: displayValue(item && item.avgDamage, "--"),
        avgDamageDeltaPerRound: displayValue(item && item.avgDamageDeltaPerRound, "--"),
        headshotPercentage: displayValue(item && item.headshotPercentage, "--"),
        kast: displayValue(item && item.kast, "--"),
        me: Boolean(item && item.me),
    };
}

function normalizeRiotMatchDetails(data, fallbackUserInfo = {}) {
    const match = data && data.matchInfo;
    if (!match) return null;
    const account = splitAccountName(match.valorantUserName);
    const matchTeamA = (Array.isArray(data.matchTeamA) ? data.matchTeamA : []).map(normalizePlayer);
    const matchTeamB = (Array.isArray(data.matchTeamB) ? data.matchTeamB : []).map(normalizePlayer);
    const currentPlayer = matchTeamA.concat(matchTeamB).find(item => item.me) || null;
    const responseUserInfo = data.userInfo || {};
    return {
        userInfo: {
            ...responseUserInfo,
            headImageUrl: displayValue(
                responseUserInfo.headImageUrl,
                displayValue(fallbackUserInfo.headImageUrl, displayValue(currentPlayer && currentPlayer.heroImageUrl, ""))
            ),
            level: displayValue(responseUserInfo.level, displayValue(fallbackUserInfo.level, 0)),
        },
        matchInfo: {
            ...match,
            playerName: displayValue(match.playerName, account.playerName || "--"),
            playerId: displayValue(match.playerId, account.playerId),
            mode: displayValue(match.modeCn || match.mode, "--"),
            map: displayValue(match.mapCn || match.map, "--"),
            selfScore: displayValue(match.selfScore, "--"),
            enemyScore: displayValue(match.enemyScore, "--"),
            playTime: formatMatchTime(match),
            showDuration: displayValue(match.showDuration, formatDuration(match.duration)),
        },
        matchTeamA,
        matchTeamB,
        matchTopImageUrl: displayValue(data.matchTopImageUrl, ""),
    };
}

function riotSeasonOptions() {
    return [{ label: "全部赛季", value: "all" }];
}

function selectRiotModeView(snapshot, queue) {
    if (!snapshot || typeof snapshot !== "object") return null;
    const mode = String(queue || "all").trim().toLowerCase() || "all";
    const views = snapshot.modeViews && typeof snapshot.modeViews === "object"
        ? snapshot.modeViews : null;
    if (views && views[mode]) return views[mode];
    if (mode === "all" && snapshot.view) return snapshot.view;
    return snapshot.emptyView || null;
}

module.exports = {
    normalizeDataSource,
    normalizeRiotMatchDetails,
    riotSeasonOptions,
    selectRiotModeView,
};
